import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const EllipsisText = styled(Box)({
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
})
